// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .statusDropdown */
.statusDropdown {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: white;
  font-weight: bold;
  cursor: pointer;
  margin: 5px;
}

.statusDropdown.pending {
  color: #ffcc00; /* Yellow */
}

.statusDropdown.accepted {
  color: #4caf50; /* Green */
}

.statusDropdown.rejected {
  color: #ff4d4d; /* Red */
}


/* close */

.studentContainer {
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin: 20px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.header h2 {
  margin: 0;
}

.filters {
  display: flex;
  gap: 10px;
}

.filterDropdown, .filterDate {
  padding: 6px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #fff;
  color: #333;
}

.filterDropdown:focus, .filterDate:focus {
  border-color: #66afe9;
  outline: none;
}

.filterDate {
  max-width: 150px;
}

.studentTable {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}

.studentTable th, .studentTable td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.studentTable th {
  background-color: #f4f4f4;
  color: #333;
}

.statusDropdown {
  padding: 6px 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #fff;
  color: #333;
}

.statusDropdown:focus {
  border-color: #66afe9;
  outline: none;
}

.statusDropdown option {
  color: #333;
  background-color: #fff;
}

  

/* 


.AdminNav{

    display: flex;
    width: 100%;
    justify-content: space-between;
    padding: 0 20px;
}

.left{
    position: sticky;
    top: 30px;
    width: 300px;
    
    background-color: goldenrod;
    padding-top: 20px;
    color: black;
    color: initial;
    height: 40vh;
}
.left h2{

     margin-left: 20px;
}

.AdminNav{
   
}

.listItem{
    text-decoration: none;
} */`, "",{"version":3,"sources":["webpack://./src/Components/Students/Students.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc,EAAE,WAAW;AAC7B;;AAEA;EACE,cAAc,EAAE,UAAU;AAC5B;;AAEA;EACE,cAAc,EAAE,QAAQ;AAC1B;;;AAGA,UAAU;;AAEV;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;;;AAIA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAiCG","sourcesContent":["/* .statusDropdown */\n.statusDropdown {\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  background-color: white;\n  font-weight: bold;\n  cursor: pointer;\n  margin: 5px;\n}\n\n.statusDropdown.pending {\n  color: #ffcc00; /* Yellow */\n}\n\n.statusDropdown.accepted {\n  color: #4caf50; /* Green */\n}\n\n.statusDropdown.rejected {\n  color: #ff4d4d; /* Red */\n}\n\n\n/* close */\n\n.studentContainer {\n  padding: 20px;\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  margin: 20px;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.header h2 {\n  margin: 0;\n}\n\n.filters {\n  display: flex;\n  gap: 10px;\n}\n\n.filterDropdown, .filterDate {\n  padding: 6px 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  background-color: #fff;\n  color: #333;\n}\n\n.filterDropdown:focus, .filterDate:focus {\n  border-color: #66afe9;\n  outline: none;\n}\n\n.filterDate {\n  max-width: 150px;\n}\n\n.studentTable {\n  width: 100%;\n  border-collapse: collapse;\n  margin-bottom: 20px;\n}\n\n.studentTable th, .studentTable td {\n  padding: 12px;\n  text-align: left;\n  border-bottom: 1px solid #ddd;\n}\n\n.studentTable th {\n  background-color: #f4f4f4;\n  color: #333;\n}\n\n.statusDropdown {\n  padding: 6px 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  background-color: #fff;\n  color: #333;\n}\n\n.statusDropdown:focus {\n  border-color: #66afe9;\n  outline: none;\n}\n\n.statusDropdown option {\n  color: #333;\n  background-color: #fff;\n}\n\n  \n\n/* \n\n\n.AdminNav{\n\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    padding: 0 20px;\n}\n\n.left{\n    position: sticky;\n    top: 30px;\n    width: 300px;\n    \n    background-color: goldenrod;\n    padding-top: 20px;\n    color: black;\n    color: initial;\n    height: 40vh;\n}\n.left h2{\n\n     margin-left: 20px;\n}\n\n.AdminNav{\n   \n}\n\n.listItem{\n    text-decoration: none;\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
